import { render } from "./JoinTheTeam.vue?vue&type=template&id=23721638&scoped=true"
import script from "./JoinTheTeam.vue?vue&type=script&lang=js"
export * from "./JoinTheTeam.vue?vue&type=script&lang=js"

import "./JoinTheTeam.vue?vue&type=style&index=0&id=23721638&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23721638"]])

export default __exports__